export const loadingAreas = {
    save: 'saveKnow',
    history: 'knowReviewHistoryContainer',
    delete: 'deleteKnow',
    plagiarism: 'plagiarismKnow',
    knowDemand: 'knowDemand',
    report: 'reportKnow',
    update: 'updateKnow',
}
